import React from "react"
import { FaCode, FaAndroid } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "Web Development",
    text: `Development of web applications with the latest technology, automation of services and optimization of existing platforms.`,
  },
  {
    id: 2,
    icon: <FaAndroid className="service-icon" />,
    title: "Mobile Application Development ",
    text: `Mobile application development for iOS and Android devices.`,
  },
]
